import { render, staticRenderFns } from "./IpQc.vue?vue&type=template&id=66886ab2"
import script from "./IpQc.vue?vue&type=script&lang=js"
export * from "./IpQc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports